import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LabelComponent } from '../../label/label.component';
import { ZskService } from '../../../../core/services/zsk.service';
import { ZGender } from '../../../../core/models/zsk.model';

@Component({
  selector: 'app-gender',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, LabelComponent],
  templateUrl: './gender.component.html',
  styleUrl: './gender.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GenderComponent),
      multi: true
    }
  ]
})
export class GenderComponent implements OnInit, ControlValueAccessor {
  @Input() label: string = 'GRAVE_FORM.GENDER';
  @Input() placeholder: string = 'GRAVE_FORM.SELECT_GENDER';
  @Input() required: boolean = false;
  @Input() id: string = 'zGenderId';
  @Input() name: string = 'zGenderId';
  genders: ZGender[] = [];
  @Input() formControl: any; // For validation in template

  value: string = '';
  disabled: boolean = false;
  submitted: boolean = false;

  // ControlValueAccessor implementation
  onChange: any = () => {};
  onTouched: any = () => {};

  constructor(public translate: TranslateService, private zskService: ZskService) {}

  ngOnInit(): void {
    this.zskService.getGender().subscribe((response) => {
      this.genders = response.data;
    });
  }

  onSelectChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    this.value = selectElement.value;
    this.onChange(this.value);
    this.onTouched();
  }

  // ControlValueAccessor methods
  writeValue(value: string): void {
    this.value = value || '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
